import {firstName, lastName} from '../field-templates/names/names';
import {email, phone} from '../field-templates/contact-info/contactInfo';
import {country, state} from '../field-templates/address/address';
import {companyName} from '../field-templates/company-name/companyName';
import {fleetSize} from '../field-templates/fleet-size/fleetSize';
import {buildField} from '../field-templates/fieldBuilder';


export default function accountBaseFields(isReferralIdCustomer){
    let referralCustomerOverride = {}
    if (isReferralIdCustomer) {
        referralCustomerOverride = {"disabled": true, "type": "input", "inputType": "text"}
    }
        return {
            groups: [
                {
                    styleClasses: "row",
                    fields: [buildField(firstName), buildField(lastName)],
                },
                {
                    styleClasses: "row",
                    fields: [buildField(email), buildField(phone)]
                },
                {
                    styleClasses: "row",
                    fields: [buildField(companyName)]
                },
                {
                    styleClasses: "row",
                    fields: [buildField(fleetSize), buildField(state), buildField(country, referralCustomerOverride)]
                },
            ]
    }
}
